import React from 'react';
import { Card, CardContent, Typography, Box, Chip, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import RoomIcon from '@mui/icons-material/Room';
import * as CONSTANTS from "../../constants";
import { getTagDisplayName } from "../../mappings/placeCategories";

const PlaceCard = ({ place, lang }) => {
    // Helper to get localized text
    const getLocalizedText = (obj) => obj?.[lang] || obj?.en || obj?.jp || obj?.tc || obj?.sc || '';

    const placeName = getLocalizedText(place.name) || place.default_name || 'Unnamed Place';
    const placeLocation = getLocalizedText(place.location) || 'Location not specified';
    const placeDescription = getLocalizedText(place.description) || '';
    const mainPhoto = place.photos && place.photos.length > 0 ? place.photos[0] : '/placeholder.jpg';

    // Example: You may want to calculate a rating and label if you have that data
    // For now, we'll use a placeholder
    const rating = place.rating || null; // If you have it
    const reviewCount = place.review_count || null; // If you have it
    const ratingLabel = rating >= 4.5 ? "Great" : rating >= 4 ? "Good" : "";

    return (
        <Card sx={{ display: 'flex', mb: 2 }}>
            {/* Image */}
            <Box sx={{ width: 120, height: 120, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: 2, m: 2 }}>
                <img
                    src={mainPhoto}
                    alt={placeName}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 8 }}
                />
            </Box>
            {/* Details */}
            <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', p: 2 }}>
                <Box>
                    <Box display="flex" alignItems="center" justifyContent="space-between">
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            <Link to={`/${lang}/places/${place.uid || place._id}/`} style={{ textDecoration: 'none', color: 'inherit' }}>
                                {placeName}
                            </Link>
                        </Typography>
                        <IconButton size="small">
                            <FavoriteBorderIcon />
                        </IconButton>
                    </Box>
                    {/* Rating and reviews */}
                    {rating && (
                        <Box display="flex" alignItems="center" mt={0.5}>
                            <Box sx={{ bgcolor: '#2a5bd7', color: 'white', px: 1, borderRadius: 1, fontWeight: 600, fontSize: 14 }}>
                                {rating.toFixed(1)}/5
                            </Box>
                            <Typography variant="body2" sx={{ ml: 1, fontWeight: 600 }}>{ratingLabel}</Typography>
                            {reviewCount && (
                                <Typography variant="body2" sx={{ ml: 1, color: 'text.secondary' }}>
                                    {reviewCount} reviews
                                </Typography>
                            )}
                        </Box>
                    )}
                    {/* Location */}
                    <Box display="flex" alignItems="center" mt={0.5}>
                        <RoomIcon fontSize="small" sx={{ color: 'text.secondary', mr: 0.5 }} />
                        <Typography variant="body2" color="text.secondary">{placeLocation}</Typography>
                    </Box>
                    {/* Description */}
                    {placeDescription && (
                        <Typography variant="body2" color="text.secondary" mt={0.5}>
                            {placeDescription}
                        </Typography>
                    )}
                    {/* Tags as badges */}
                    <Box mt={1} display="flex" flexWrap="wrap" gap={0.5}>
                        {place.tags && place.tags.map((tagNumber) => (
                            <Chip
                                key={tagNumber}
                                label={getTagDisplayName(tagNumber, lang)}
                                size="small"
                                color="primary"
                                variant="outlined"
                            />
                        ))}
                    </Box>
                </Box>
                {/* Example: Add price, deals, or other info here if you want */}
            </Box>
        </Card>
    );
};

export default PlaceCard; 